// Docs: https://mymth.github.io/vanillajs-datepicker/#/

// import Datepicker from '../../../../node_modules/vanillajs-datepicker/js/Datepicker.js'
// import DateRangePicker from '../../../../node_modules/vanillajs-datepicker/js/DateRangePicker.js'

// @ts-ignore
import { Datepicker, DateRangePicker } from 'vanillajs-datepicker'
// import is from '../../../../node_modules/vanillajs-datepicker/js/i18n/locales/is.js'

// import Datepicker from 'vanillajs-datepicker/Datepicker'

const DPicker = {
  el: {
    singles: document.querySelectorAll<HTMLInputElement>('.dpicker'),
    doubles: document.querySelectorAll<HTMLDivElement>('.dpicker--double'),
  },
  init() {
    this.singles()
    this.doubles()    
  },
  singles() {
    if (document.querySelectorAll<HTMLInputElement>('.dpicker').length > 0) {
      Array.prototype.forEach.call(document.querySelectorAll<HTMLInputElement>('.dpicker'), item => {

        // @ts-ignore
        new Datepicker(item, {
          format: 'dd.mm.yyyy',
          autohide: true,
          pickLevel: 0,
          minDate: new Date(),
        })
      })
    }
  },
  doubles() {    
    if (document.querySelectorAll<HTMLDivElement>('.dpicker--double').length > 0) {
      Array.prototype.forEach.call(document.querySelectorAll<HTMLDivElement>('.dpicker--double'), item => {

        // @ts-ignore
        new DateRangePicker(item, {
          format: 'dd.mm.yyyy',
          pickLevel: 0,
          autohide: true,
          minDate: new Date(),
        })
      })
    }
  },
}

export default DPicker
